import templateMatchingTestCasesData from '../../data/adaptToProduct/templateMatchingTestCases.json';
import type { SelectorOption } from '../common/types';

interface SourceDocumentOption extends SelectorOption {
    productName?: string;
}

export const TEST_CASE_SOURCE_DOCUMENT_OPTIONS: SourceDocumentOption[] = templateMatchingTestCasesData.map(
    (testCase) => ({
        label: `Template Matching: ${testCase.label}`,
        value: testCase.sourceDocumentUrl,
        productName: testCase.sourceProductName,
    }),
);

const normalize = (value: string) => value.toLowerCase().replace(/[^a-z0-9]/g, '');

/**
 * Source documents that can be used for the given source product.
 * Documents without a productName are shown for every product, since their product is unknown.
 * Every document is shown while no source product is set.
 */
export const getSourceDocumentOptions = (
    sampleDocuments: SelectorOption[],
    sourceProductName: string,
): SourceDocumentOption[] => {
    const documents: SourceDocumentOption[] = [...TEST_CASE_SOURCE_DOCUMENT_OPTIONS, ...sampleDocuments];

    if (!normalize(sourceProductName)) {
        return documents;
    }

    return documents.filter(
        (document) => !document.productName || normalize(document.productName) === normalize(sourceProductName),
    );
};

export const getProductNameForSourceDocument = (
    sourceDocumentUrl: string,
    sampleDocuments: SelectorOption[],
): string | undefined =>
    getSourceDocumentOptions(sampleDocuments, '').find((document) => document.value === sourceDocumentUrl)?.productName;
